<script lang="ts">
	import '../app.css';
	import Header from '$lib/components/layout/Header.svelte';
	import Footer from '$lib/components/layout/Footer.svelte';
	import { Toaster } from 'svelte-sonner';
	import { dev } from '$app/environment';
	import { inject } from '@vercel/analytics';

	// Initialize analytics in an effect to ensure proper lifecycle management
	$effect(() => {
		inject({ mode: dev ? 'development' : 'production' });
	});

	let { children } = $props();
</script>

<Toaster richColors closeButton position="top-right" />
<div class="flex min-h-screen flex-col">
	<Header />
	<main class="flex-1">
		{@render children()}
	</main>
	<Footer />
</div>
